// extracted by mini-css-extract-plugin
export default {"benefitWrapper":"Benefit_wrapper_benefitWrapper__MIzky","benefitWrapperContent":"Benefit_wrapper_benefitWrapperContent__qdKED"};